import { useState } from 'react';

function isStringArrayEqual(a: string[], b: string[]) {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export function useStringArrayMemo<T extends string[]>(value: T): T {
  const [prevValue, setPrevValue] = useState(value);

  if (!isStringArrayEqual(value, prevValue)) {
    setPrevValue(value);
  }

  return prevValue;
}
